import { Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';

@Injectable({ providedIn: 'root' })
export class FieldSelectionFactory {
  constructor() {}

  isImageFieldSupported(namespace: Namespace | string): boolean {
    if (namespace === Namespace.bullhorn) {
      return true;
    }

    if (namespace === Namespace.salesforce) {
      return false;
    }

    if (namespace === Namespace.invenias) {
      return false;
    }

    throw new Error(`Image fields are not supported for '${namespace}'.`);
  }
}
